<template>
    <div class="main-container">
        <div class="page-header">
            <div class="page-header-content">
                <div class="avatar">
                    <span>{{
                        userInfo.name ? userInfo.name.substring(0, 1) : "U"
                    }}</span>
                </div>
                <div class="content">
                    <div class="content-title">
                        <span>{{ userInfo.name || "用户姓名" }}</span>
                        <div class="welcome-text">欢迎使用智慧物流系统</div>
                    </div>
                    <div class="content-desc">
                        <div class="status">
                            <span class="status-dot"></span>
                            <span>在线</span>
                        </div>
                        <div class="role-list">
                            <el-tag
                                v-for="(
                                    role, index
                                ) in userInfo.roleNames.split(',')"
                                :key="index"
                                :type="getTagType(index)"
                                size="small"
                                style="margin-right: 5px"
                            >
                                {{ role }}
                            </el-tag>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-wrapper">
            <div class="user-profile-card">
                <div class="card-title">
                    <span>个人信息</span>
                </div>
                <div class="card-body">
                    <div class="info-list">
                        <div class="info-item">
                            <div class="info-label">用户姓名</div>
                            <div class="info-value">
                                {{ userInfo.name || "未设置" }}
                            </div>
                        </div>
                        <div class="info-item">
                            <div class="info-label">用户角色</div>
                            <div class="info-value">
                                <el-tag
                                    v-for="(
                                        role, index
                                    ) in userInfo.roleNames.split(',')"
                                    :key="index"
                                    :type="getTagType(index)"
                                    size="small"
                                    style="margin-right: 5px"
                                >
                                    {{ role }}
                                </el-tag>
                                <span
                                    v-if="
                                        !userInfo.roles ||
                                        userInfo.roles.length === 0
                                    "
                                    class="empty-value"
                                    >暂无角色</span
                                >
                            </div>
                        </div>
                        <div class="info-item">
                            <div class="info-label">手机号码</div>
                            <div class="info-value">
                                {{ userInfo.code || "未设置" }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-actions">
                    <el-button
                        type="primary"
                        icon="el-icon-edit"
                        @click="editProfile"
                        >修改密码</el-button
                    >
                    <el-button icon="el-icon-switch-button" @click="logout"
                        >退出登录</el-button
                    >
                </div>
            </div>

            <div class="help-card">
                <div class="card-title">
                    <span>帮助</span>
                </div>
                <div class="card-body">
                    <div class="help-item">
                        <div class="help-icon">
                            <i class="el-icon-document"></i>
                        </div>
                        <div class="help-content">
                            <div class="help-title">后台管理系统使用文档</div>
                            <div class="help-desc">下载详细操作指南，快速上手系统</div>
                            <el-button type="primary" size="small" @click="downloadTemplate">
                                下载文档
                            </el-button>
                        </div>
                    </div>
                    <div class="help-item">
                        <div class="help-icon">
                            <i class="el-icon-video-play"></i>
                        </div>
                        <div class="help-content">
                            <div class="help-title">驾驶员小程序演示视频</div>
                            <div class="help-desc">观看系统功能演示，了解使用方法</div>
                            <el-button type="primary" size="small" @click="openVideo">
                                观看视频
                            </el-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <chgpwd ref="chgpwdRef"></chgpwd>
    </div>
</template>

<script>
import chgpwd from "@/basicLayout/EditPass.vue";
export default {
    components: {
        chgpwd,
    },
    data() {
        return {
            // 移除systemSlogans数据
        };
    },
    computed: {
        userInfo() {
            return this.$store.state.app.userInfo;
        },
    },

    methods: {
        getTagType(index) {
            const types = ["primary", "success", "warning", "danger", "info"];
            return types[index % types.length];
        },
        editProfile() {
            this.$refs.chgpwdRef.open();
        },
         downloadTemplate() {
            //通过a标签下载文件
            var a = document.createElement("a");
            a.href = "./file/途灵物流软件操作流程.docx";
            a.download = "途灵物流软件操作流程.docx";
            a.click();
        },
        openVideo() {
            // 打开演示视频
            window.open('https://www.douyin.com/user/self?from_tab_name=main&modal_id=7612495113836004514', '_blank');
        },
        async logout() {
            this.$store.dispatch("app/changeMenuLoading", true);
            await this.$store.dispatch("upms/loginOut");

            setTimeout(() => {
                this.$store.dispatch("app/changeMenuLoading", false);
                this.$router.replace({
                    name: "login",
                });
            }, 1000);
        },
    },
};
</script>

<style lang="scss" scoped>
.main-container {
    background: #f0f2f5;
    width: 100%;
    height: 100%;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
        "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji",
        "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    font-size: 14px;
    color: rgba(0, 0, 0, 0.85);
    line-height: 1.5715;
}

/* 页面头部 */
.page-header {
    background-color: #fff;
    padding: 16px 24px;
    border-radius: 2px;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.03),
        0 1px 6px -1px rgba(0, 0, 0, 0.02), 0 2px 4px 0 rgba(0, 0, 0, 0.02);
    margin-bottom: 24px;

    .page-header-content {
        display: flex;
        align-items: center;

        .avatar {
            width: 64px;
            height: 64px;
            border-radius: 50%;
            margin-right: 24px;
            background: #1890ff;
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 24px;
            font-weight: 500;
            overflow: hidden;

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }

        .content {
            flex: 1;

            .content-title {
                margin-bottom: 12px;

                span {
                    font-size: 20px;
                    font-weight: 500;
                    line-height: 28px;
                    color: rgba(0, 0, 0, 0.85);
                    margin-right: 12px;
                }

                .welcome-text {
                    font-size: 14px;
                    color: rgba(0, 0, 0, 0.45);
                }
            }

            .content-desc {
                display: flex;
                align-items: center;

                .status {
                    display: flex;
                    align-items: center;
                    margin-right: 16px;

                    .status-dot {
                        width: 8px;
                        height: 8px;
                        border-radius: 50%;
                        background-color: #52c41a;
                        margin-right: 8px;
                    }
                }
            }
        }
    }
}

/* 内容区域 */
.content-wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 24px;

    .user-profile-card,
    .help-card {
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.03),
            0 1px 6px -1px rgba(0, 0, 0, 0.02), 0 2px 4px 0 rgba(0, 0, 0, 0.02);
        overflow: hidden;

        .card-title {
            padding: 16px 24px;
            border-bottom: 1px solid #f0f0f0;
            color: rgba(0, 0, 0, 0.85);
            font-weight: 500;
            font-size: 16px;
        }

        .card-body {
            padding: 24px;
        }
    }

    .user-profile-card {
        flex: 1;
        min-width: 300px;

        .info-list {
            .info-item {
                display: flex;
                margin-bottom: 16px;

                &:last-child {
                    margin-bottom: 0;
                }

                .info-label {
                    width: 100px;
                    color: rgba(0, 0, 0, 0.65);
                }

                .info-value {
                    flex: 1;
                    color: rgba(0, 0, 0, 0.85);

                    .el-tag {
                        margin-right: 8px;
                        margin-bottom: 8px;
                    }

                    .empty-value {
                        color: rgba(0, 0, 0, 0.25);
                        font-style: italic;
                    }
                }
            }
        }

        .card-actions {
            padding: 16px 24px;
            border-top: 1px solid #f0f0f0;
            text-align: right;

            .el-button {
                margin-left: 8px;
            }
        }
    }

    .help-card {
        flex: 1;
        min-width: 300px;

        .help-item {
            display: flex;
            margin-bottom: 20px;

            &:last-child {
                margin-bottom: 0;
            }

            .help-icon {
                width: 50px;
                height: 50px;
                background-color: #e6f7ff;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-right: 16px;
                color: #1890ff;
                font-size: 24px;
            }

            .help-content {
                flex: 1;

                .help-title {
                    font-size: 16px;
                    font-weight: 500;
                    color: rgba(0, 0, 0, 0.85);
                    margin-bottom: 4px;
                }

                .help-desc {
                    font-size: 14px;
                    color: rgba(0, 0, 0, 0.45);
                    margin-bottom: 12px;
                }
            }
        }
    }
}

/* 顶部标语区域 */
.slogan-container {
    position: relative;
    z-index: 1;
    text-align: center;
    margin-bottom: 40px;

    .slogan {
        font-size: 3rem;
        font-weight: bold;
        margin-bottom: 10px;
        background: linear-gradient(90deg, #1890ff, #722ed1);
        -webkit-background-clip: text;
        background-clip: text;
        color: transparent;
        letter-spacing: 2px;
    }

    .sub-slogan {
        font-size: 1.2rem;
        color: #666;
        letter-spacing: 1px;
    }
}

/* 用户信息卡片 */
.user-card {
    position: relative;
    z-index: 1;
    width: 100%;
    max-width: 600px;
    margin: 0 auto 40px;
    background: #ffffff;
    border-radius: 15px;
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
    overflow: hidden;
    transition: transform 0.3s, box-shadow 0.3s;

    &:hover {
        transform: translateY(-5px);
        box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
    }

    &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 5px;
        background: linear-gradient(90deg, #1890ff, #722ed1);
    }
}

.card-header {
    display: flex;
    align-items: center;
    padding: 25px;
    border-bottom: 1px solid #f0f0f0;
}

.user-avatar {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    overflow: hidden;
    margin-right: 20px;
    border: 2px solid #1890ff;
    box-shadow: 0 0 15px rgba(24, 144, 255, 0.2);

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .avatar-placeholder {
        width: 100%;
        height: 100%;
        background: linear-gradient(135deg, #1890ff, #722ed1);
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 2rem;
        font-weight: bold;
        color: #ffffff;
    }
}

.user-title {
    flex: 1;

    h2 {
        margin: 0 0 10px;
        font-size: 1.8rem;
        font-weight: 600;
        color: #333;
    }
}

.user-status {
    display: flex;
    align-items: center;

    .status-dot {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: #52c41a;
        margin-right: 8px;
        animation: pulse 2s infinite;
    }

    .status-text {
        font-size: 0.9rem;
        color: #666;
    }
}

@keyframes pulse {
    0% {
        box-shadow: 0 0 0 0 rgba(76, 175, 80, 0.7);
    }
    70% {
        box-shadow: 0 0 0 10px rgba(76, 175, 80, 0);
    }
    100% {
        box-shadow: 0 0 0 0 rgba(76, 175, 80, 0);
    }
}

.card-content {
    padding: 25px;
}

.info-item {
    display: flex;
    margin-bottom: 20px;

    &:last-child {
        margin-bottom: 0;
    }
}

.info-label {
    width: 120px;
    display: flex;
    align-items: center;
    color: #666;

    i {
        margin-right: 8px;
        font-size: 1.2rem;
        color: #1890ff;
    }
}

.info-value {
    flex: 1;
    color: #333;

    .el-tag {
        margin-right: 8px;
        margin-bottom: 5px;
    }

    .empty-value {
        color: #999;
        font-style: italic;
    }
}

.card-footer {
    display: flex;
    justify-content: center;
    padding: 20px 25px;
    border-top: 1px solid #f0f0f0;

    .el-button {
        margin: 0 10px;
    }
}

/* 系统标语轮播 */
.slogans-carousel {
    position: relative;
    z-index: 1;
    width: 100%;
    max-width: 800px;
    margin: 0 auto 40px;

    .el-carousel {
        border-radius: 10px;
        overflow: hidden;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    }

    .carousel-content {
        height: 120px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #ffffff;
        border: 1px solid #f0f0f0;

        p {
            font-size: 1.5rem;
            text-align: center;
            padding: 0 30px;
            font-weight: 500;
            letter-spacing: 1px;
            background: linear-gradient(90deg, #1890ff, #722ed1);
            -webkit-background-clip: text;
            background-clip: text;
            color: transparent;
        }
    }
}

/* 响应式设计 */
@media (max-width: 768px) {
    .page-header {
        .page-header-content {
            flex-direction: column;
            text-align: center;

            .avatar {
                margin-right: 0;
                margin-bottom: 16px;
            }

            .content {
                .content-desc {
                    justify-content: center;

                    .status {
                        margin-right: 0;
                        margin-bottom: 8px;
                    }
                }
            }
        }
    }

    .content-wrapper {
        flex-direction: column;

        .user-profile-card,
        .help-card {
            min-width: auto;
        }
    }
}
</style>
